import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, breakpoints }: Theme) => ({
  root: {
    backgroundColor: custom.pageHeader.backgroundColor,
    paddingTop: 24,
    paddingBottom: 64,
    [breakpoints.down(1024)]: {
      paddingTop: 0,
      paddingBottom: 48,
    },
  },
  contentWrapper: {
    display: 'flex',
    justifyContent: 'center',
    maxWidth: custom.pageWidth,
    margin: 'auto',
    position: 'relative',
    paddingLeft: 20,
    paddingRight: 20,
  },
  title: {
    margin: 0,
    ...custom.pageHeader.title,
    fontSize: 40,
    lineHeight: '46px',
    color: custom.grey[3],
    textAlign: 'center',
    [breakpoints.down(1024)]: {
      fontSize: 32,
      lineHeight: '42px',
    },
  },
  img: {
    position: 'absolute',
    right: 0,
    bottom: -67,
    margin: '0 20px',
    [breakpoints.down(1024)]: {
      display: 'none',
    },
  },
}));
